import { useNavigate } from 'react-router-dom'

interface IProps {
  title: any
  value: any
  percentage: any
  bgClass: any
  iconClass: any
  cardStyle: any
}

export const CountCard: React.FC<IProps> = ({
  title,
  value,
  percentage,
  bgClass,
  iconClass,
  cardStyle
}) => {
  const cardBackgroundImage = {
    clients:
      'url(https://cdn.iconscout.com/icon/premium/png-256-thumb/profile-3243718-2705251.png)',
    users: 'url(https://cdn.iconscout.com/icon/premium/png-256-thumb/profile-3243718-2705251.png)',
    roles: 'url(https://cdn.iconscout.com/icon/premium/png-256-thumb/profile-3243718-2705251.png)',
    plans: 'url(https://file.removal.ai/preview/9543b1a0-ab08-4492-8fcd-139a6133d156-ga.png'
  }

  return (
    <>
      <div className='col-xl-4 col-lg-6 col-md-6 col-xm-12'>
        <div
          className='card cursor-pointer'
          style={{
            background: `${cardStyle}`,
            color: 'white'
          }}
        >
          <div
            className='card-body'
            style={{
              backgroundImage: cardBackgroundImage.plans
            }}
          >
            <div className='d-flex align-items-start justify-content-between'>
              <div className='content-left'>
                <span>{title}</span>
                <div className='d-flex align-items-end mt-2'>
                  <h4 className='mb-0 me-2 fs-1 text-white'>{value}</h4>
                  <small className='text-success mb-0'>{percentage}</small>
                </div>
              </div>
              <div className='avatar'>
                <span className='avatar-initial rounded bg-label danger'>
                  <i
                    className='bi bi-people-fill bg-white p-4 rounded h3'
                    style={{ color: `${cardStyle}` }}
                  ></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
